import React from 'react';
import {SearchResultItemType} from "../../search/sections/navigation-menu/@type";
import {EntityType} from "../../../core/gd/const/item";
import NavigationMenuItemProjectWithChildren from "../../menu/menu-items/project/menu-item-project-with-children";
import NavigationMenuItemTask from "../../menu/menu-items/task/menu-item-task";
import NavigationMenuItemUser from "../../menu/menu-items/user/menu-item-user";
import NavigationMenuItemDocument from "../../menu/menu-items/document/menu-item";

type Props = {
    menuItem: SearchResultItemType
}

export default function MenuSearch_PinResult(props: Props) {

    if(!props.menuItem.pin) return null

    const pin = props.menuItem.pin

    switch (pin.type) {

        case EntityType.PROJECT:
            return  <NavigationMenuItemProjectWithChildren projectId                     = {pin.project!.id}
                                                           colorized                     = {true}
                                                           localSettings                 = {{}}
                                                           expandedProjectsSettingName   = "expandedPinnedProjects"/>

        case EntityType.TASK_TYPE:
            return <NavigationMenuItemTask task={pin.task!} />

        case EntityType.USER:
            return <NavigationMenuItemUser companyUser={gd.session.companyUsers.get(pin.user!.companyId + "-" + pin.user!.userId)} />

        case EntityType.DOCUMENT:
            return <NavigationMenuItemDocument document={pin.document!} />

        default:
            throw Error("#kjjjjf9873 Unknown type " + pin.type);
    }

}
